// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-carousel/image-carousel.component.scss
// module id = 368
// module chunks = 0